import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20spacious%20bright%20workspace%20with%20a%20laptop%20showing%20a%20colorful%20organized%20spreadsheet%2C%20surrounded%20by%20neatly%20arranged%20shopping%20boxes%2C%20sneakers%20and%20fashion%20accessories%20on%20wooden%20shelves%2C%20warm%20natural%20window%20light%2C%20soft%20sage%20green%20and%20cream%20tones%2C%20airy%20editorial%20composition%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=1600&height=900&seq=hero-usfans-01&orientation=landscape&nocache=true"
          alt="USFans Spreadsheet resource hub background"
          title="USFans Spreadsheet resource hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-28">
        <div className="mx-auto max-w-4xl text-center">
          <p className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm font-semibold tracking-widest uppercase backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400" />
            {t('hero.eyebrow')}
          </p>

          <h1 className="mt-6 text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 leading-tight">
            {t('hero.title')}
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-50/90 leading-relaxed max-w-2xl mx-auto">
            {t('hero.subtitle')}
          </p>

          {/* Search */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="mt-8 mx-auto max-w-xl flex items-center gap-2 bg-background-50 rounded-full p-1.5 pl-5"
          >
            <i className="ri-search-line text-foreground-500 text-lg" />
            <input
              type="text"
              placeholder={t('hero.searchPlaceholder')}
              className="flex-1 bg-transparent text-foreground-900 text-sm outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="h-10 px-5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              {t('hero.ctaPrimary')}
            </button>
          </form>

          {/* CTA buttons */}
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              usfans spreadsheet
              <i className="ri-arrow-right-up-line text-lg" />
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-base font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors"
            >
              {t('nav.buyNow')}
            </a>
          </div>

          <p className="mt-8 text-sm text-background-50/80">{t('hero.trust')}</p>
        </div>
      </div>
    </section>
  );
}